<script setup>
import { onBeforeMount, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";

import setNavPills from "@/assets/js/nav-pills.js";
import setTooltip from "@/assets/js/tooltip.js";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";

const body = document.getElementsByTagName("body")[0];
const store = useStore();

onMounted(() => {
  store.state.isAbsolute = true;
  setNavPills();
  setTooltip();
});
onBeforeMount(() => {
  store.state.imageLayout = "profile-overview";
  store.state.showSidenav = false;
  store.state.showNavbar = false;
  store.state.showFooter = true;
  store.state.hideConfigButton = true;
  body.classList.add("profile-overview");
  if (localStorage.getItem("token")) {
    store.state.showSidenav = true;
    status = true;
  }
});
onBeforeUnmount(() => {
  store.state.isAbsolute = false;
  store.state.imageLayout = "default";
  store.state.showNavbar = true;
  store.state.showFooter = true;
  store.state.hideConfigButton = false;
  body.classList.remove("profile-overview");
});
</script>
<template>
  <main>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-md-8">
          <div class="card">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0" v-text="Registro"></p>
              </div>
            </div>
           <div class="card-body">
              <p class="text-uppercase text-sm">Alta de Tienda</p>
              <div class="row">
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Nombre de Tienda</label
                  >
                  <input
                    class="form-control"
                    type="text"
                    v-model="miStore.nombre"
                  />
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Nombre de Contacto</label
                  >
                  <argon-input v-model="miStore.contacto" />
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Tel de Contacto</label
                  >
                  <argon-input v-model="miStore.tel" />
                </div>
              </div>
              <hr class="horizontal dark" />
              <p class="text-uppercase text-sm">
                Information de Tienda
              </p>
              <div class="row">
                 <div class="col-md-12">
                  <label for="example-text-input" class="form-control-label"
                    >Direccion</label
                  >
                  <argon-input type="text" v-model="miStore.direccion" />
                </div>
                <argon-button
                  class="mt-4"
                  variant="gradient"
                  color="success"
                  fullWidth
                  size="sm"
                  @click.prevent="alta"
                  >Dar Alta</argon-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
// import ArgonRadio from "@/components/ArgonRadio.vue";
import Swal from "sweetalert2";
import apistores from "../api/stores";
export default {
  components: {
    ArgonInput,
  },
  data() {
    return {
      status: null,
      miStore: {
        id: 0,
        nombre: null,
        contacto:null,
        direccion: null,
        tel: null,
        status: 0,
        fechaCreacion: "",
        token: null,
      },
    };
  },
  created() {},
  methods: {
    async saveData() {
      this.loaddata();
      apistores
        .update(this.model)
        .then((result) => {
          if (result.data.message != null) {
            Swal.fire({
              title: "Actualizacion Correcta",
              text: result.data.message,
              icon: "success",
              confirmButtonColor: "success",
              confirmButtonText: "Continuar",
            });
            this.$router.push({ path: "/productos" });
          } else {
            Swal.fire({
              title: "Error al Actualizar Producto",
              text: result.data.error,
              icon: "error",
              confirmButtonColor: "error",
              confirmButtonText: "Continuar",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async alta() {
      this.loaddata();
      apistores
        .alta(this.miStore)
        .then((result) => {
          if (result.data.message != null) {
            Swal.fire({
              title: "Alta Correcta",
              text: result.data.message,
              icon: "success",
              confirmButtonColor: "success",
              confirmButtonText: "Continuar",
            });
            this.$router.push({ path: "/stores" });
          } else {
            Swal.fire({
              title: "Error al Insertar Tienda",
              text: result.data.error,
              icon: "error",
              confirmButtonColor: "error",
              confirmButtonText: "Continuar",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async updateData() {
      this.model.token = localStorage.getItem("token");
      apistores
        .update(this.miStore)
        .then((result) => {
          if (result.data.message != null) {
            Swal.fire({
              title: "Actualizacion Correcta",
              text: result.data.message,
              icon: "success",
              confirmButtonColor: "success",
              confirmButtonText: "Continuar",
            });
            this.model = null;
            this.$router.push({ path: "/usuarios" });
          } else {
            Swal.fire({
              title: "Error al actualizar",
              text: result.data.error,
              icon: "error",
              confirmButtonColor: "error",
              confirmButtonText: "Continuar",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loaddata() {
      this.miStore.token = localStorage.getItem("token");
    },
  },
};
</script>
